import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const NetworkErrorFillSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<g clipPath="url(#clip0_22248_21994)">
				<path
					d="M19.2586 44.6853C20.7425 43.1977 22.5058 42.018 24.4471 41.214C26.3884 40.4099 28.4694 39.9973 30.5706 40C32.6722 39.997 34.7538 40.4094 36.6955 41.2134C38.6373 42.0175 40.401 43.1974 41.8853 44.6853L30.5706 56L19.2586 44.6853Z"
					fill="#BDBDBD"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M30.9319 26.6677C27.171 26.6977 23.4502 27.4529 19.9739 28.893C17.651 29.8552 15.4672 31.1108 13.4741 32.6252C11.7135 33.9629 9.192 33.9902 7.62846 32.4266L1.03125 25.8294C4.98899 21.8616 9.69184 18.715 14.8695 16.5705C19.8837 14.4938 25.2474 13.3965 30.671 13.336V13.3335C30.757 13.3334 30.843 13.3335 30.929 13.3339C31.0199 13.3335 31.1109 13.3333 31.2019 13.3334V13.3361C36.6255 13.3965 41.9892 14.4939 47.0034 16.5706C52.1811 18.7151 56.8839 21.8617 60.8417 25.8295L51.4123 35.2588C48.6916 32.5309 45.4585 30.3676 41.899 28.8931C38.4199 27.4519 34.696 26.6965 30.9319 26.6677Z"
					fill="#262A2F"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M30.8674 40.0014C28.8469 40.0288 26.8493 40.4398 24.9811 41.2134C24.2772 41.5049 23.5967 41.8458 22.9443 42.2329C21.0428 43.3612 18.523 43.4169 16.9595 41.8534L10.3647 35.2586C13.0855 32.5308 16.3185 30.3674 19.878 28.8929C23.2904 27.4793 26.9383 26.7256 30.6286 26.6699V26.6666C30.7082 26.6665 30.7878 26.6668 30.8674 26.6673C30.9469 26.6668 31.0265 26.6665 31.1061 26.6666V26.6699C34.7964 26.7256 38.4443 27.4793 41.8567 28.8929C45.4162 30.3674 48.6492 32.5308 51.37 35.2586L41.9433 44.6853C40.459 43.1974 38.6953 42.0175 36.7536 41.2134C34.8854 40.4398 32.8878 40.0288 30.8674 40.0014Z"
					fill="#4A4A4A"
				/>
				<ellipse cx="53.8332" cy="18.6667" rx="10.6667" ry="10.6667" fill="url(#paint0_linear_22248_21994)" />
				<path
					d="M58.6649 14.9802C58.9811 14.664 58.9811 14.1513 58.6649 13.8352C58.3487 13.519 57.8361 13.519 57.5199 13.8352L53.8333 17.5217L50.1468 13.8352C49.8306 13.519 49.318 13.519 49.0018 13.8352C48.6856 14.1513 48.6856 14.664 49.0018 14.9802L52.6883 18.6667L49.0018 22.3533C48.6856 22.6694 48.6856 23.1821 49.0018 23.4983C49.318 23.8144 49.8306 23.8144 50.1468 23.4983L53.8333 19.8117L57.5199 23.4983C57.8361 23.8144 58.3487 23.8144 58.6649 23.4983C58.9811 23.1821 58.9811 22.6694 58.6649 22.3533L54.9783 18.6667L58.6649 14.9802Z"
					fill="white"
					stroke="white"
					strokeWidth="0.1"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_22248_21994"
					x1="53.8332"
					y1="8"
					x2="53.8332"
					y2="29.3333"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#FF4D4D" />
					<stop offset="1" stopColor="#FF9999" />
				</linearGradient>
				<clipPath id="clip0_22248_21994">
					<rect width="64" height="64" fill="white" transform="translate(0.5)" />
				</clipPath>
			</defs>
		</IPortIconTemplate>
	)
})
